import { BaseService } from "mrb/core";
import { AppStoreHomeSectionApiRouteService } from "common/services";

class AppStoreHomeSectionService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new AppStoreHomeSectionApiRouteService());
    }

    getNakiAll(options, abortSignal = null) {
        const url = this.routeService.getNakiAll(options);
        return this.apiClient.get(url, null, null, abortSignal);
    }

    getLoadioAll(options, abortSignal = null) {
        const url = this.routeService.getLoadioAll(options);
        return this.apiClient.get(url, null, null, abortSignal);
    }

    getNakiContent(options, abortSignal = null) {
        const url = this.routeService.getNakiContent(options);
        return this.apiClient.get(url, null, null, abortSignal);
    }

    getLoadioContent(options, abortSignal = null) {
        const url = this.routeService.getLoadioContent(options);
        return this.apiClient.get(url, null, null, abortSignal);
    }

    updateNaki(resource, abortSignal = null) {
        const url = this.routeService.updateNaki(resource);
        return this.apiClient.put(url, resource, null, abortSignal);
    }

    updateLoadio(resource, abortSignal = null) {
        const url = this.routeService.updateLoadio(resource);
        return this.apiClient.put(url, resource, null, abortSignal);
    }

    updateNakiFeatured(resource, abortSignal = null) {
        const url = this.routeService.updateNakiFeatured(resource);
        return this.apiClient.put(url, resource, null, abortSignal);
    }

    updateLoadioFeatured(resource, abortSignal = null) {
        const url = this.routeService.updateLoadioFeatured(resource);
        return this.apiClient.put(url, resource, null, abortSignal);
    }

    getLoadioFeatured(options, abortSignal = null) {
        const url = this.routeService.getLoadioFeatured(options);
        return this.apiClient.get(url, null, null, abortSignal);
    }

    getNakiFeatured(options, abortSignal = null) {
        const url = this.routeService.getNakiFeatured(options);
        return this.apiClient.get(url, null, null, abortSignal);
    }
}

export default AppStoreHomeSectionService;
